import { Component } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent {
  constructor(public authService: AuthService) { }

  tryLoginAgain() {
    this.authService.init();
  }

  logout() {
    this.authService.logout();
  }
}
